import React, { Component } from "react";
import "./ProfileUpdate.css";
import Footer from "../../component/Footer/Footer";
import LayoutWrapper from "../../component/LayoutWrapper/";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import PropTypes from "prop-types";
import {
  updateProfile,
  doProfileDataUpdateRes,
} from "../../action/ProfileDataUpdateAction";
import {
  showProfile,
  doProfileDetailsListRes,
} from "../../action/ProfileDetailsListAction";
import loaderImg from "../../assets/images/loader-example.gif";
import Loader from "react-loader-advanced";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

class ProfileUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmited: false,
      first_name: "",
      user_email: "",
      mobile: "",
      showProfile: false,
      showUpdate: false,
      isLoader: false,
    };
    ReactGA.initialize("UA-64201999-5");
    ReactGA.pageview(window.location.pathname + window.location.search);

    ReactPixel.init("784849368913134");

    ReactPixel.pageView();
  }

  validate(values) {
    const errors = {};

    if (values.first_name && values.first_name.trim() === "") {
      errors.password = "*Please enter name";
    } else if (values.first_name === null) {
      errors.first_name = "*Please enter name";
    } else if (values.first_name === undefined) {
      errors.first_name = "*Please enter name";
    } else if (values.first_name === "") {
      errors.first_name = "*Please enter name";
    }

    if (values.mobile && values.mobile.trim() === "") {
      errors.mobile = "*Please enter contact number";
    } else if (values.mobile === null) {
      errors.mobile = "*Please enter contact number";
    } else if (values.mobile === undefined) {
      errors.mobile = "*Please enter contact number";
    } else if (values.mobile === "") {
      errors.mobile = "*Please enter contact number";
    }

    return errors;
  }

  detaileSubmit = (e) => {
    e.preventDefault();
    this.setState(
      {
        isSubmited: true,
        showUpdate: true,
      },
      () => { }
    );
    this.validate(this.state);
    const errors = this.validate(this.state);
    if (Object.keys(errors).length === 0) {
      let requestData = {
        first_name: this.state.first_name,
        mobile: this.state.mobile,
        user_id: this.state.user_id,
      };
      this.setState({
        isLoader: true,
      });
      this.props.updateProfile(requestData);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.doProfileDataUpdateRes &&
      nextProps.doProfileDataUpdateRes.user
    ) {
      if (
        nextProps.doProfileDataUpdateRes.user &&
        nextProps.doProfileDataUpdateRes.user.ProfileUpdateDataRes
      ) {
        if (
          nextProps.doProfileDataUpdateRes.user.ProfileUpdateDataRes &&
          nextProps.doProfileDataUpdateRes.user.ProfileUpdateDataRes.success ===
          true &&
          this.state.showUpdate === true
        ) {
          this.setState(
            {
              showProfile: true,
              showUpdate: false,
              isLoader: false,
            },
            () => {
              if (this.state.showProfile) {
                const data = {
                  userId: localStorage.getItem("userId"),
                };

                this.props.showProfile(data);
              }
            }
          );
        } else {
          this.setState({
            isLoader: false,
          });
        }
      }
    }

    if (
      nextProps.doProfileDetailsListRes &&
      nextProps.doProfileDetailsListRes.user
    ) {
      if (
        nextProps.doProfileDetailsListRes.user &&
        nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes
      ) {
        if (
          nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes &&
          nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes
            .result === true
        ) {
          localStorage.setItem(
            "userName",
            nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes.profile
              .first_name
          );
          this.setState({
            user_id:
              nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes
                .profile.user_id,
            first_name:
              nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes
                .profile.first_name,
            user_email:
              nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes
                .profile.user_email,
            mobile:
              nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes
                .profile.mobile,
            // showProfile: false,
            isLoader: false,
          });
        } else {
          this.setState({
            isLoader: false,
          });
        }
      }
    }
  }

  componentDidMount() {
    const data = {
      userId: localStorage.getItem("userId"),
    };
    this.setState({
      isLoader: true,
    });
    this.props.showProfile(data);
  }

  logOut = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  render() {
    // const content = this.state.checked
    const errors = this.validate(this.state);
    const { isSubmited } = this.state;
    const spinner = (
      <span>
        <img src={loaderImg} alt="" />
      </span>
    );
    return (
      <React.Fragment>
        <Loader show={this.state.isLoader} message={spinner}>
          <LayoutWrapper />

          <main className="main">
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <div className="container">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Profile Update
                  </li>
                </ol>
              </div>
              {/* End .container  */}
            </nav>
            <div className="container">
              <div className="row">
                <div className="col-lg-9 order-lg-last dashboard-content">
                  <h2>Edit Account Information</h2>
                  <form onSubmit={this.detaileSubmit}>
                    <div className="form-group required-field">
                      <label htmlFor="acc-email">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="acc-email"
                        name="first_name"
                        onChange={(e) =>
                          this.setState({ first_name: e.target.value })
                        }
                        value={this.state.first_name}
                      />
                      {errors && isSubmited && (
                        <span className="error-message">
                          {errors.first_name}
                        </span>
                      )}
                    </div>
                    {/* End .form-group */}

                    <div className="form-group">
                      <label htmlFor="acc-password">Email Id</label>
                      <input
                        type="email"
                        className="form-control"
                        id="acc-password"
                        name="user_email"
                        onChange={(e) =>
                          this.setState({ user_email: e.target.value })
                        }
                        value={this.state.user_email}
                        disabled
                      />
                    </div>
                    {/* End .form-group */}

                    <div className="form-group required-field">
                      <label htmlFor="acc-email">Contact</label>
                      <input
                        type="number"
                        className="form-control"
                        id="acc-email"
                        name="mobile"
                        onChange={(e) =>
                          this.setState({ mobile: e.target.value })
                        }
                        value={this.state.mobile}
                      />
                      {errors && isSubmited && (
                        <span className="error-message">{errors.mobile}</span>
                      )}
                    </div>

                    <div className="mb-2"></div>
                    {/* margin */}

                    {/* <div className="required text-right">* Required Field</div> */}
                    <div className="form-footer">
                      <div className="form-footer-right">
                        <button
                          type="submit"
                          className="btn btn-primary show-color"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                    {/* End .form-footer */}
                  </form>
                </div>
                {/* End .col-lg- */}

                <aside className="sidebar col-lg-3">
                  <div className="widget widget-dashboard">
                    <h3 className="widget-title">My Account</h3>

                    <ul className="list">
                      <li className="active">
                        <a href="/profile-update">Account Details</a>
                      </li>
                      {/* <li><a href="my-account.html#">Account Information</a></li>
                                                    <li><a href="/checkoutshippingaddress">Address Book</a></li>
                                                    <li><a href="/order-history">My Orders</a></li> */}

                      <li>
                        <a href="/my-wallet">My Wallet</a>
                      </li>
                      <li>
                        <a href="/address-info">Address Info</a>
                      </li>
                      <li>
                        <a href="/change-password">Change-Password</a>
                      </li>
                      {/* <li><a href="my-account.html#">Recurring Profiles</a></li>
                                                    <li><a href="my-account.html#">My Product Reviews</a></li>*/}
                      <li>
                        <a href="/order-history">My Order</a>
                      </li>
                      <li><a href="/corporate-order-history">Corporate Order</a></li>
                      <li>
                        <span
                          className="logoutLi"
                          onClick={() => this.logOut()}
                        >
                          Logout
                        </span>
                      </li>
                    </ul>
                  </div>
                  {/* End .widget */}
                </aside>
                {/* End .col-lg-3 */}
              </div>
              {/* End .row */}
            </div>
            {/* End .container  */}
            <div className="mb-5"></div>
            {/* margin  */}
          </main>
          {/* End .main */}
        </Loader>
        <Footer />
      </React.Fragment>
    );
  }
}

ProfileUpdate.propTypes = {
  doProfileDataUpdateRes: PropTypes.any,
  doProfileDetailsListRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  doProfileDataUpdateRes: doProfileDataUpdateRes,
  doProfileDetailsListRes: doProfileDetailsListRes,
});

function mapDispatchToProps(dispatch) {
  return {
    updateProfile: (data) => dispatch(updateProfile(data)),
    showProfile: (data) => dispatch(showProfile(data)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(ProfileUpdate);
